import React, { useState } from 'react';
import get from 'lodash/get';
import { Layout } from 'antd';
import { useSelector } from 'react-redux';
import { BrowserRouter } from 'react-router-dom';
import LayoutHeader from './components/LayoutHeader';
import Sidebar from './components/AppLayout/Sidebar';
import AuthRoutes from './routes/AuthRoutes';

const { Content } = Layout;

const AppRouter = () => {
    const isLoggedIn = useSelector((state) => get(state, 'auth.isLoggedIn'));
    const [collapsed, setCollapsed] = useState(false);

    return (
        <BrowserRouter>
            <Layout className='parent-layout' hasSider>
                {isLoggedIn && (
                    <Sidebar collapsed={collapsed} onCollapse={setCollapsed} />
                )}

                <Layout className='main-layout'>
                    {isLoggedIn && (
                        <LayoutHeader
                            collapsed={collapsed}
                            onToggle={() => setCollapsed((prev) => !prev)}
                        />
                    )}

                    <Content className={isLoggedIn ? 'screen-content' : 'auth-content'}>
                        <AuthRoutes />
                    </Content>
                </Layout>
            </Layout>
        </BrowserRouter>
    );
};

export default AppRouter;
